<template>
  <section class="discoverPage">
    <h1>HIGHGROUND</h1>
    <h3>Product Suite</h3>
    <div class="discoverPageLogo">
      <img :src="logo" alt="Evntl-Logo">
    </div>
    <p>EVNTL’s Critical Event Notification System exploits a unique natural language processing capability embedded within a broader and proprietary AI platform, to identify, locate and ensure the truth and veracity of breaking events.</p>
    <div class="button" @click="toDiscover">
      Discover
    </div>
  </section>
</template>

<script>
import EvntlLogo from '@/assets/hgMain/evntlLogo.svg';

export default {
  name: 'DiscoverPage',
  data() {
    return {
      logo: EvntlLogo
    }
  },
  methods: {
    toDiscover() {
      this.$router.push('/Discover');
    }
  },
}
</script>

<style scoped>
@media (min-width: 600px) {
  .discoverPage {
    position: relative;
    text-align: center;
    margin: 0 auto;
  }
  .discoverPage > h1 {
    margin-bottom: 0;
    font-size: 5vw;
  }
  .discoverPage > h3 {
    margin: 0 0;
    font-weight: normal;
    font-size: 2vw;
  }
  .discoverPage > p {
    font-weight: normal;
    color: #1e1e1e;
    margin: 5rem 10rem;
    font-size: 2vw;
  }
  .discoverPageLogo {
    margin-bottom: 3rem;
  }
  .discoverPageLogo > img {
    margin-top: 2rem;
    height: auto;
    width: 50%;
  }
  .button {
    cursor: pointer;
    font-size: 3vw;
    margin-right: 35%;
    margin-left: 35%;
    margin-bottom: 6rem;
    border-style: solid;
    border-radius: 0.5rem;
  }
}
@media (max-width: 600px) {
  .discoverPage {
    position: relative;
    text-align: center;
    margin: 0 auto;
  }
  .discoverPage > h1 {
    margin-bottom: 0;
    font-size: 6vw;
  }
  .discoverPage > h3 {
    margin: 0 0;
    font-weight: normal;
    font-size: 3vw;
  }
  .discoverPage > p {
    font-weight: normal;
    color: #1e1e1e;
    margin: 1rem 2rem;
    font-size: 3vw;
  }
  .discoverPageLogo {
    margin-bottom: 3rem;
  }
  .discoverPageLogo > img {
    margin-top: 2rem;
    height: auto;
    width: 50%;
  }
  .button {
    cursor: pointer;
    font-size: 3vw;
    margin-right: 35%;
    margin-left: 35%;
    margin-bottom: 3rem;
    box-shadow: 0 0 0.5rem #ccc;
    border-style: solid;
    border-radius: 0.5rem;
  }
}
</style>
